// core version + navigation modules:
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';

new Swiper( '.events', {
	// configure Swiper to use modules.
	modules: [ Navigation ],
	// Default parameters.
	slidesPerView: 1.2,
	speed: 400,
	spaceBetween: 24,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	// Responsive breakpoints.
	breakpoints: {
		// when window width is >= 768px.
		768: {
			slidesPerView: 2,
		},
		// when window width is >= 1280px.
		1280: {
			slidesPerView: 4,
		},
	},
} );
